export default __webpack_public_path__ + "static/media/nutricion_enteral.35890c9c.pdf";